import {
    Component,
    ElementRef,
    Input,
    ViewChild
} from '@angular/core';
import { Overlay } from '../../baseObjects/overlay';

// services
import { OverlayService } from '../../services/overlay.service';
import { OverlayPosition } from '../../classes/overlay-position';

@Component({
    selector: 'tooltip',
    templateUrl: 'tooltip.component.html',
    host: { 'class': 'tooltip component' }
})
export class TooltipComponent extends Overlay {
    // io
    @Input() set visible(value: boolean) {
        if (value) {
            this.show();
        } else {
            this.hide();
        }
    }

    // content
    @ViewChild('wrapper') private _wrapper: ElementRef;

    constructor(
        private elementRef: ElementRef,
        private overlayService: OverlayService
    ) {
        super();
        this.coordinates = new OverlayPosition();
    }

    ngOnInit() {
        if (!this.target) {
            this.elementRef.nativeElement.parentElement.addEventListener('mouseover', this.show.bind(this));
            this.elementRef.nativeElement.parentElement.addEventListener('mouseleave', this.hide.bind(this));
        }
    }

    show() {
        this.overlayService.showTooltip(this._wrapper);
        this.positionToTarget();
    }

    hide() {
        this.overlayService.removeTooltip(this._wrapper);
    }

    positionToTarget() {
        let targetRect: any;
        switch (typeof this.target) {
            case 'string':
                targetRect = document.getElementById(this.target as string).getBoundingClientRect();
                break;
            default:
                targetRect = this.elementRef.nativeElement.parentElement.getBoundingClientRect();
                break;
        }

        let wrapperRect = this._wrapper.nativeElement.getBoundingClientRect();
        if (this.position === 'bottom') {
            let wrapperMiddleX = wrapperRect.width/2;
            let targetMiddleX = targetRect.width / 2 + targetRect.left + window.scrollX - wrapperMiddleX;
            let targetY = targetRect.bottom + window.scrollY;
            this.coordinates = { top: `${targetY + 10}px`, right: 'auto', left: `${targetMiddleX}px`, bottom: 'auto' };
        }
    }
}



// WEBPACK FOOTER //
// ./client-src/app/core/components/tooltip/tooltip.component.ts